<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <div class="mission_banner_wrapper full_banner_content consultany_main_banner">
                <div class="about_main_image">
                    <img src="../../assets/images/consultancy-services.png"  alt="consultancy-services" />

                    <h5>CONSULTANCY SERVICES:</h5>
                </div>
            </div>
            <div class="consultancy_content_sec">
                <div class="container">
                    <h5>The Healthcare industry is burdened with rapidly evolving market needs
                    and regulatory forces along with cultural shifts and patient-centered
                    systems. Nama understands each player and has the pledge to leverage
                    your capabilities and drive value for your today’s business. We offer a set
                    of dedicated consultancy services that could benefit healthcare providers,
                    health insurance, and governing authorities.</h5>

                    <div class="row d-flex justify-content-center">
                      <div class="col-md-11">
                      <h3 class="primary-color">Our services include the following:</h3>

                      <h4 class="mt-4">Performance Measurements: </h4>
                      <p>Measuring the quality of Patient Centred Care, hospitals functionality-KPIs, external auditing, and reporting clinical outcomes through digital solutions using AI/ML. .</p>

                      <h4 class="mt-5">Health Policy Evaluation</h4>
                      <p>Using Cluster Randomized Trials (CRT), Difference-in-Differences (DiD), or Interrupted time series (ITS), we provide insights about a new policy impact with cost-effectiveness analysis.</p>

                      <h4 class="mt-5">Efficiency Management</h4>
                      <p>Productivity assessments, hospital, and departmental benchmarking, right-sizing staffing levels, and staff scheduling to ensure you have the most efficient practice in place.</p>

                      <!--<h4 class="mt-5">Efficiency Management</h4>
                      <p>Productivity assessments, hospital, and departmental benchmarking,
                      right-sizing staffing levels, and staff scheduling to ensure you have the
                      most efficient practice in place.</p>-->

                        <div class="text-center mt-5">
                          <router-link v-bind:to="'/contact-us/'" class="read_more">Need help or have a question ?</router-link>
                        </div>
                      </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
import EventBus from '../EventBus'

export default{
    data(){
        return {
            current_locale:this.$i18n_global.locale
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    methods:{

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/ConsultancyServices.vue